/**
 * User service for the account-scoped user-management API (`/api/v1/users`).
 *
 * Operates on the caller's own account (gamemaster/admin). Distinct from
 * `accountsService`, whose user endpoints are admin-only and cross-account.
 */

import apiClient from '../api/client';
import { User } from '../types/auth';
import { UserCreate, UserListResponse, UserUpdate } from '../types/user';

export const usersService = {
    /** List users in the caller's account. */
    async getUsers(skip = 0, limit = 100): Promise<UserListResponse> {
        const response = await apiClient.get<UserListResponse>('/api/v1/users', {
            params: { skip, limit },
        });
        return response.data;
    },

    /** Create a user in the caller's account (pending + invite email). */
    async createUser(data: UserCreate): Promise<User> {
        const response = await apiClient.post<User>('/api/v1/users', data);
        return response.data;
    },

    /** Edit a user, or deactivate/reactivate via `is_active`. */
    async updateUser(userId: string, data: UserUpdate): Promise<User> {
        const response = await apiClient.patch<User>(`/api/v1/users/${userId}`, data);
        return response.data;
    },
};

export default usersService;
